<nx-file-upload-status
  [isUploading]="data.file.isUploading"
  [isUploaded]="!data.field.hideSuccessUpload && data.file.isUploaded"
  [uploadedLabel]="data.field.options?.uploadedLabel ?? data.templateContext.uploadedLabel | translate"
></nx-file-upload-status>
